/** Settings flow id from Kratos browser_location_change_required (admin recovery → password). */
export function settingsFlowIdFromRedirect(data) {
  const raw = data?.redirect_browser_to;
  if (typeof raw !== "string" || !raw.trim()) return null;
  try {
    const url = new URL(raw, "https://placeholder.local");
    if (!url.pathname.includes("/settings")) return null;
    const id = url.searchParams.get("flow");
    return id != null && id.trim() !== "" ? id.trim() : null;
  } catch {
    return null;
  }
}

/** Extract CSRF token from a Kratos browser flow payload. */
export function csrfFromFlow(flow) {
  const nodes = flow?.ui?.nodes;
  if (!Array.isArray(nodes)) return "";
  const node = nodes.find((n) => n?.attributes?.name === "csrf_token");
  return node?.attributes?.value != null ? String(node.attributes.value) : "";
}

/** First UI message text for an error display. */
export function firstFlowMessage(flow) {
  const msgs = flow?.ui?.messages;
  if (!Array.isArray(msgs) || !msgs.length) return "";
  return String(msgs[0]?.text || "");
}

/** Which recovery screen matches the current Kratos flow UI nodes. */
export function recoveryStepFromFlow(flow) {
  const names = (flow?.ui?.nodes || []).map((n) => n?.attributes?.name).filter(Boolean);
  if (names.includes("password")) return "password";
  if (names.includes("code")) return "code";
  return "email";
}

/**
 * Kratos may return redirect_browser_to under public base (…/auth/login).
 * Always land on the React route /login, never the Kratos proxy path.
 */
export function appPathAfterRecovery(data) {
  const raw = data?.redirect_browser_to;
  if (typeof raw === "string" && raw.trim()) {
    try {
      const path = new URL(raw, window.location.origin).pathname;
      if (path === "/auth/login" || path.endsWith("/auth/login")) return "/login";
    } catch {
      /* ignore */
    }
  }
  return "/login";
}

/** Map Kratos post-login redirect_browser_to to a React app path (never nginx /auth/). */
export function appPathAfterLogin(data) {
  const raw = data?.redirect_browser_to;
  if (typeof raw !== "string" || !raw.trim()) return "/";
  try {
    const url = new URL(raw, window.location.origin);
    const path = url.pathname;
    if (path === "/auth/login" || path.endsWith("/auth/login")) return "/login";
    if (path.startsWith("/auth/")) return "/";
    return `${path}${url.search}` || "/";
  } catch {
    return "/";
  }
}
